import { Card } from "@/components/ui/card";
import { Landmark, ShieldCheck, Scale, Users } from "lucide-react";

export default function AboutRFC() {
  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-12" data-testid="about-rfc-page">
      <div className="text-xs uppercase tracking-widest text-teal-700 font-semibold mb-2">Our NBFC</div>
      <h1 className="text-4xl sm:text-5xl font-semibold text-slate-900 mb-3">About Red Fort Capital Finance</h1>
      <p className="text-slate-600 max-w-3xl mb-10 leading-relaxed">
        Red Fort Capital Finance is a Non-Banking Financial Company (NBFC) focused on practical,
        cash-flow based lending for India's real economy — shop owners, traders, transport operators,
        farmers and salaried families across Tier 1, 2 and 3 markets. CarFin India is its digital
        used car loan operating platform, combining CarDr vehicle diagnostics with cash-flow
        underwriting to lend on the <em>true</em> value of the vehicle and the <em>true</em> repayment
        ability of the borrower.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        <Card className="p-6 border-slate-200">
          <Landmark className="text-teal-600 mb-3" size={22} />
          <div className="font-semibold text-slate-900 mb-2">Own-book + co-lending model</div>
          <p className="text-sm text-slate-600 leading-relaxed">Loans are originated on Red Fort Capital's own book and may be co-lent with partner banks and NBFCs under RBI co-lending guidelines, with transparent split disclosures.</p>
        </Card>
        <Card className="p-6 border-slate-200">
          <ShieldCheck className="text-teal-600 mb-3" size={22} />
          <div className="font-semibold text-slate-900 mb-2">RBI digital lending compliant</div>
          <p className="text-sm text-slate-600 leading-relaxed">Key Fact Statements, APR disclosure, explicit consent for bureau & Account Aggregator data, fair practices code and a grievance redressal mechanism on every loan.</p>
        </Card>
        <Card className="p-6 border-slate-200">
          <Scale className="text-teal-600 mb-3" size={22} />
          <div className="font-semibold text-slate-900 mb-2">Board-approved credit policy</div>
          <p className="text-sm text-slate-600 leading-relaxed">Every decision flows through a configurable, versioned and audited credit policy engine — CIBIL floors, FOIR caps, vehicle-grade LTV matrices and exception approval authority.</p>
        </Card>
        <Card className="p-6 border-slate-200">
          <Users className="text-teal-600 mb-3" size={22} />
          <div className="font-semibold text-slate-900 mb-2">Built for Bharat's borrowers</div>
          <p className="text-sm text-slate-600 leading-relaxed">Self-employed, thin-file and cash-income borrowers are first-class citizens — underwritten on real bank cash flow, references and vehicle quality, not just formal documents.</p>
        </Card>
      </div>

      <div className="p-5 rounded-lg bg-slate-900 text-slate-100 text-sm leading-relaxed">
        “CarFin India originates used car loans through Red Fort Capital Finance NBFC and may support bank/NBFC co-lending partners.”
        <div className="text-xs text-slate-400 mt-2">Grievance: grievance@carfin.com · Regd. Office: [Address line] · CIN: [CIN]</div>
      </div>
    </div>
  );
}
